import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Utils } from '../utils.class';

@Injectable({ providedIn: 'root' })
export class LoggerService {
    constructor(private http: HttpClient) {}

    logError(error) {
        try {
            const errorPayload = typeof error === 'string' ? error : JSON.stringify(error);

            this.sendData(errorPayload);
        } catch (e) {}
    }

    private async sendData(error) {
        try {
            const url = window?.location?.href;
            const versionInfo = await Utils.checkVersion();

            this.http
                .post(`${environment.apiEndpoint}logging/app`, {
                    app_version: versionInfo,
                    exception: error,
                    url,
                })
                .pipe(catchError(_ => of([])))
                .subscribe();
        } catch (e) {}
    }
}
